import { toOptions } from './ArrayUtil';
// export const subjectsData = ['ことば学習', '国語', '算数/数学', '理科', '社会', '英語'];
export const subjectsData = ['ことば学習', '国語', '算数', '英語', '理科', '社会'];
export const subjectsOptions = toOptions(subjectsData);
